import { render, staticRenderFns } from "./dividendInfo.vue?vue&type=template&id=797b896c&scoped=true"
import script from "./dividendInfo.vue?vue&type=script&lang=js"
export * from "./dividendInfo.vue?vue&type=script&lang=js"
import style0 from "./dividendInfo.vue?vue&type=style&index=0&id=797b896c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797b896c",
  null
  
)

export default component.exports